<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-2">
        {{ $t("edit") }} {{ $tc("banner", 1) }}
      </div>
      <router-link class="btn-blue" :to="{ name: 'Web Banners' }"
        >{{ $tc("banner", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <div class="row mx-1">
        <div
          class="col-12 d-flex new-border back rounded-10"
          style="
            flex-wrap: wrap;
            padding-top: 11px;
            padding-left: 0px;
            padding-right: 0px;
          "
        >
          <div class="col-lg-4 col-xl-3 align-self-center mb-0">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    banner_type && banner_type.length > 0 ? 'shift-up' : ''
                  "
                  >{{ $tc("banner", 1) }} {{ $tc("type", 1) }}
                </label>
                <b-dropdown
                  :text="banner_type"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(bannerType, bannerTypeIndex) in banner_types"
                    :key="bannerTypeIndex"
                    v-on:click="onSelectBannerType(bannerType)"
                    >{{ bannerType.banner_type }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
          <!-- CINEMA SELECTION -->

          <div class="col-lg-4 col-xl-3 align-self-center mb-0">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  id="banner_name"
                  name="banner_name"
                  v-validate="'required'"
                  v-model="banner_name"
                  placeholder="."
                  maxlength="100"
                  v-on:keydown="checkInputLength"
                  v-b-tooltip.hover
                  :title="$t('banner_name')"
                />
                <label>Banner Name</label>
              </div>
              <!--Tooltip :title="$t('banner_name')" /-->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('banner_name')">{{
                errors.first("banner_name")
              }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-4 align-self-center mb-0">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  id="banner_description"
                  name="banner_description"
                  v-validate="'required'"
                  v-model="banner_description"
                  placeholder="Description"
                  maxlength="300"
                  v-on:keydown="checkInputLength"
                  v-b-tooltip.hover
                  :title="$t('banner_description')"
                />
                <label>Description</label>
              </div>
              <!--Tooltip :title="$t('banner_description')" /--->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('banner_description')">{{
                errors.first("banner_description")
              }}</span>
            </p>
          </div>

          <div class="col-2 d-flex align-self-center align-items-center">
            <label class="mb-0 mr-2">{{ $t("active") }}</label>

            <b-form-checkbox
              type="checkbox"
              class="j-checkbox mb-0"
              v-model="banner_is_active"
            />
          </div>

          <div
            v-if="banner_type_id === 1 || banner_type_id === 2"
            class="col-12 row pt-2 mb-3 new-border rounded-10"
            style="
              background-color: white;
              padding-left: 0px;
              margin-left: 15px;
              max-width: 95%;
            "
          >
            <div
              v-if="banner_type_id === 1"
              class="col-lg-6 col-xl-4 align-self-center mb-2"
            >
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="
                      movie_name && movie_name.length > 0 ? 'shift-up' : ''
                    "
                    >{{ $tc("movie", 1) }}</label
                  >
                  <b-dropdown
                    :text="movie_name"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <div class="px-2 pb-2">
                      <input
                        required
                        autofocus
                        type="search"
                        placeholder="Search Movie"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchMovie($event.target.value)"
                        v-on:keydown="onSearchMovie($event.target.value)"
                        v-on:search="onSearchMovie($event.target.value)"
                        v-model="searchMovie"
                      />
                    </div>
                    <b-dropdown-item
                      v-for="(movie, movieIndex) in MovieList"
                      :key="movieIndex"
                      v-on:click="onSelectMovie(movie)"
                      >{{ movie.movie_title }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </div>
            </div>

            <div
              class="col-lg-8 mb-2 align-self-center"
              v-if="banner_type_id === 1"
            >
              <div class="row mx-0">
                <b-form-checkbox
                  v-for="(type, typeIndex) in movieType"
                  :key="typeIndex"
                  v-model="type.checked"
                  class="j-checkbox mx-3 mb-0"
                >
                  <div class="text-capitalize">{{ type.name }}</div>
                </b-form-checkbox>
              </div>
            </div>

            <div class="col-lg-6 mb-1" v-if="banner_type_id === 1 && false">
              <div class="d-flex align-items-center">
                <b-form-radio
                  :value="1"
                  class="j-radio"
                  v-model="movie_banner_type_id"
                >
                  <div>
                    <span>{{ "Now Showing" }}</span>
                  </div>
                </b-form-radio>
                <strong class="mx-3">OR</strong>

                <b-form-radio
                  :value="2"
                  class="j-radio"
                  v-model="movie_banner_type_id"
                >
                  <div>
                    <span>{{ "On Demand" }}</span>
                  </div>
                </b-form-radio>
              </div>
            </div>

            <div
              class="col-lg-6 col-xl-4 align-self-center mb-2"
              v-if="banner_type_id === 2"
            >
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    id="generic_url"
                    name="generic_url"
                    @input="OnType($event)"
                    v-model="generic_url"
                    placeholder="."
                    maxlength="255"
                    v-on:keydown="checkInputLength"
                  />
                  <label>Generic URL</label>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="col-lg-5 col-xl-3 mb-5 pr-0" v-if="banner_type_id">
          <label class="material-file-upload">
            <input
              :disabled="isMovieSelected"
              type="file"
              v-on:change="setBannerImage($event)"
              name="image"
              id="image"
            />
            <div
              class="label"
              v-bind:class="{
                'shift-up':
                  banner_image.image_setting_path &&
                  banner_image.image_setting_path.length > 0
              }"
            >
              <div class="text-truncate">
                {{ banner_image.image_setting_name }}
              </div>
            </div>
            <div class="uploaded-file-name">
              <div class="text-truncate pt-2">
                {{ banner_image.image_setting_path }}
              </div>
            </div>
          </label>
        </div>
        <div
          class="col-1 mb-4"
          v-if="
            banner_image.image_setting_path &&
              banner_image.image_setting_path.length > 0
          "
        >
          <img
            v-if="
              banner_image.image_setting_path &&
                banner_image.image_setting_path.length > 0
            "
            :src="_GetImagePath(banner_image.image_setting_path)"
            @click="
              openImageModal(
                banner_image.image_setting_name,
                banner_image.image_setting_path
              )
            "
            height="38"
            width="38"
            class="rounded c-pointer"
          />
          <img
            v-else
            src="@/assets/img/icons/empty-image.svg"
            height="35"
            width="35"
            class="rounded"
          />
        </div> -->

          <div class="col-lg-12 col-xl-12 align-self-center mb-1 row">
            <div class="col-lg-4 col-xl-3 align-self-center mb-1">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="from_date"
                      @click="resetFromDate('from_date')"
                    >
                      ✖
                    </button>
                    <Datepicker
                      :monday-first="true"
                      ref="programaticOpen"
                      v-model="from_date"
                      name="fdate1"
                      id="fdate1"
                      typeable
                      v-validate=""
                      v-b-tooltip.hover
                      :title="$t('fromdate')"
                    ></Datepicker>
                    <label :class="from_date ? 'active' : ''">From</label>
                  </div>
                </div>
                <!--Tooltip :title="$t('fromdate')" /-->
              </div>
              <!-- <p v-if="submitted && errors.has('fdate1')" class="error_message">
                {{ errors.first("fdate1") }}
              </p> -->
            </div>

            <div class="col-lg-4 col-xl-3 align-self-center mb-1">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="to_date"
                      @click="resetFromDate('to_date')"
                    >
                      ✖
                    </button>
                    <Datepicker
                      :monday-first="true"
                      ref="programaticOpen"
                      v-model="to_date"
                      name="todate"
                      id="todate"
                      typeable
                      v-validate=""
                      v-b-tooltip.hover
                      :title="$t('todate')"
                    ></Datepicker>
                    <label :class="to_date ? 'active' : ''">To</label>
                  </div>
                </div>
                <!--Tooltip :title="$t('todate')" /-->
              </div>
              <!-- <p v-if="submitted && errors.has('todate')" class="error_message">
                {{ errors.first("todate") }}
              </p> -->
            </div>
            <div class="col-lg-6 col-xl-3 my-2">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    selectedOfferId.os_id ? 'shift-up' : 'font-weight-bold'
                  "
                  >Offers</label
                >
                <div class>
                  <multiselect
                    v-model="selectedOfferId"
                    placeholder=""
                    :options="offersList"
                    label="offer_title"
                    track-by="os_id"
                    :multiple="false"
                  >
                  </multiselect>
                </div>
              </div>
            </div>
            <div
              class="col-2 mb-1 d-flex align-items-center justify-content-center"
            >
              <label class="mb-0 mr-3">{{ $t("fade") }}</label>

              <b-form-checkbox
                type="checkbox"
                class="j-checkbox"
                v-model="fade"
              />
              <span class="switch-slider"></span>
            </div>
            <p class="error_message">
              <span></span>
            </p>

            <div class="d-flex align-items-center">
              <div
                class="col-md-4 mb-1 d-flex align-items-center"
                style="gap: 10px"
                v-if="
                  CinemasGroupedByRegion && CinemasGroupedByRegion.length > 0
                "
              >
                <h6 class="mb-0">Cinema</h6>
                <div
                  v-for="regionObj in CinemasGroupedByRegion"
                  :key="regionObj[0]"
                  v-if="regionObj[1].length > 0"
                  class="my-1"
                >
                  <div class="d-flex align-items-center my-1">
                    <p class="m-0 cursor-pointer">
                      {{ regionObj[1][0].region_name }}:
                    </p>

                    <div class="d-flex ml-1">
                      <b-button
                        v-for="(cinema, cinemaIndex) in regionObj[1]"
                        :key="cinemaIndex"
                        :class="`mx-1 cursor-pointer custom-button`"
                        @click="onClickSelectCinema(cinema, cinemaIndex)"
                        :variant="
                          selectedCinema.findIndex(
                            (x) => x.cine_id == cinema.cine_id
                          ) !== -1
                            ? 'primary'
                            : 'outline-primary'
                        "
                        >{{ cinema.cine_code }}</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-md-4 mb-1 d-flex align-items-center"
                style="gap: 10px"
                v-else
              >
                <h6>Select Cinema</h6>
                <p class="mt-0"> No cinemas found. Please add some cinemas. </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 Language-section px-3 mb-2">
          <div
            v-for="(BannerLang, BannerLangIndex) in BannerContent"
            :key="BannerLangIndex"
            class="row new-border back rounded-10 mt-2"
          >
            <h5 class="col-md-12 mt-3 mb-3 d-flex">
              <span>{{ BannerLang.langauge }}</span>
              <button
                @click.prevent.stop="
                  translateToOtherLangs(BannerLang, BannerLangIndex)
                "
                class="btn-blue btn-blue-sm ml-2"
              >
                Translate &nbsp;
                <b-spinner
                  v-if="translationLoading[BannerLangIndex] == true"
                  small
                  variant="light"
                  label="Spinning"
                  class="translate-spinner"
                ></b-spinner>
              </button>
            </h5>

            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="BannerLang.banner_header"
                    placeholder="."
                    name="banner_header"
                    id="banner_header"
                    maxlength="200"
                    v-on:keydown="checkInputLength"
                    v-b-tooltip.hover
                    :title="$t('banner_header')"
                  />
                  <label>Header</label>
                </div>
                <!--Tooltip :title="$t('banner_header')" /-->
              </div>
              <p class="error_message">
                <span
                  v-if="
                    submitted &&
                    BannerLang.langauge.toLowerCase() === 'english' &&
                    errors.has('banner_header')
                  "
                  >{{ errors.first("banner_header") }}</span
                >
              </p>
            </div>

            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="BannerLang.banner_subheader"
                    placeholder="."
                    name="banner_subheader"
                    id="banner_subheader"
                    maxlength="200"
                    v-on:keydown="checkInputLength"
                    v-b-tooltip.hover
                    :title="$t('banner_subheader')"
                  />
                  <label>Sub-Header</label>
                </div>
                <!--Tooltip :title="$t('banner_subheader')" /-->
              </div>
              <p class="error_message">
                <span
                  v-if="
                    submitted &&
                    BannerLang.langauge.toLowerCase() === 'english' &&
                    errors.has('banner_subheader')
                  "
                  >{{ errors.first("banner_subheader") }}</span
                >
              </p>
            </div>

            <div class="col-md-3">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="BannerLang.button_text"
                    placeholder="."
                    name="banner_subheader"
                    id="banner_subheader"
                    maxlength="255"
                    v-on:keydown="checkInputLength"
                    v-b-tooltip.hover
                    :title="$t('button_text_tooltip')"
                  />
                  <label>Button Text</label>
                </div>
                <!--Tooltip :title="$t('button_text_tooltip')" /-->
              </div>
              <p class="error_message">
                <span
                  v-if="
                    submitted &&
                    BannerLang.langauge.toLowerCase() === 'english' &&
                    errors.has('button_text')
                  "
                  >{{ errors.first("button_text") }}</span
                >
              </p>
            </div>

            <div class="col-md-4">
              <div class="row">
                <div class="col-8">
                  <div class="d-flex align-items-center">
                    <label
                      class="material-file-upload"
                      style="background-color: white"
                      @click.prevent.stop="
                        setModalData(
                          banner_image_height,
                          banner_image_width,
                          BannerLangIndex,
                          1
                        )
                      "
                      v-b-tooltip.hover
                      src="@/assets/img/icons/question.svg"
                      :title="
                        'Banner Image' +
                        '- ' +
                        banner_image_width +
                        ' X ' +
                        banner_image_height
                      "
                    >
                      <div
                        class="label"
                        v-bind:class="{
                          'shift-up':
                            BannerLang.banner_image.image_setting_path &&
                            BannerLang.banner_image.image_setting_path.length >
                              0,
                        }"
                      >
                        {{ BannerLang.banner_image.image_setting_name }}
                        {{
                          "- " +
                          banner_image_width +
                          " X " +
                          banner_image_height
                        }}
                      </div>
                      <div class="uploaded-file-name">
                        <div class="text-truncate pt-2">
                          {{ BannerLang.banner_image.image_setting_path }}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <div class="col-4 align-self-center pl-3">
                  <ImagePreviewer
                    :img="
                      _GetImagePath(BannerLang.banner_image.image_setting_path)
                    "
                    :clickFunc="
                      () => {
                        openImageModal(
                          BannerLang.banner_image.image_setting_name,
                          BannerLang.banner_image.image_setting_path
                        );
                      }
                    "
                  />
                  <img
                    v-if="BannerLang.banner_image.image_setting_path"
                    src="@/assets/img/icons/download.svg"
                    height="25"
                    width="25"
                    class="rounded cursor-pointer"
                    @click="downloadImage(BannerLang, 1)"
                  />
                  <img
                    v-if="BannerLang.banner_image.image_setting_path"
                    src="@/assets/img/icons/trash.svg"
                    height="25"
                    width="25"
                    class="rounded cursor-pointer"
                    @click="removeImageHandler(BannerLang, 1)"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-4" v-if="mobileImageSettingAvailable">
              <div class="row">
                <div class="col-8">
                  <div class="d-flex align-items-center">
                    <label
                      style="background-color: white"
                      class="material-file-upload"
                      @click.prevent.stop="
                        setModalData(
                          mobile_banner_image_height,
                          mobile_banner_image_width,
                          BannerLangIndex,
                          2
                        )
                      "
                      v-b-tooltip.hover
                      src="@/assets/img/icons/question.svg"
                      :title="
                        'Mobile Banner' +
                        '- ' +
                        mobile_banner_image_width +
                        ' X ' +
                        mobile_banner_image_height
                      "
                    >
                      <div
                        class="label"
                        v-bind:class="{
                          'shift-up':
                            BannerLang.mobile_banner_image.image_setting_path &&
                            BannerLang.mobile_banner_image.image_setting_path
                              .length > 0,
                        }"
                      >
                        {{ BannerLang.mobile_banner_image.image_setting_name }}
                        {{
                          "- " +
                          mobile_banner_image_width +
                          " X " +
                          mobile_banner_image_height
                        }}
                      </div>
                      <div class="uploaded-file-name">
                        <div class="text-truncate pt-2">
                          {{
                            BannerLang.mobile_banner_image.image_setting_path
                          }}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <div class="col-4 align-self-center pl-3">
                  <ImagePreviewer
                    :clickFunc="
                      () => {
                        openImageModal(
                          BannerLang.mobile_banner_image.image_setting_name,
                          BannerLang.mobile_banner_image.image_setting_path
                        );
                      }
                    "
                    :img="
                      _GetImagePath(
                        BannerLang.mobile_banner_image.image_setting_path
                      )
                    "
                    v-if="BannerLang.mobile_banner_image.image_setting_path"
                  />
                  <img
                    v-if="BannerLang.mobile_banner_image.image_setting_path"
                    src="@/assets/img/icons/download.svg"
                    height="25"
                    width="25"
                    class="rounded cursor-pointer"
                    @click="downloadImage(BannerLang, 2)"
                  />
                  <img
                    v-if="BannerLang.mobile_banner_image.image_setting_path"
                    src="@/assets/img/icons/trash.svg"
                    height="25"
                    width="25"
                    class="rounded cursor-pointer"
                    @click="removeImageHandler(BannerLang, 2)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="editBanner()"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            :to="{ path: '/master/banners' }"
            >{{ $t("cancel") }}</b-button
          >
        </div>
        <!-- MOVIE BANNER IMAGE MODAL -->
        <b-modal
          ref="preview-modal"
          id="selected-image-preview-modal"
          size="lg"
          hide-header
          hide-footer
        >
          <label class="h4 mt-2 mb-4 text-center">{{
            tempModalImageName
          }}</label>
          <button
            class="btn-modal-close"
            @click="$bvModal.hide('selected-image-preview-modal')"
          >
            &times;
          </button>
          <br />
          <img :src="_GetImagePath(tempModalImagePath)" class="img-fluid" />
        </b-modal>
        <!-- IMAGE CROPPER -->
        <b-modal
          id="imagecropper"
          body-class="banner-cropper"
          hide-header
          hide-footer
          no-close-on-backdrop
        >
          <label class="h4 mt-2 mb-4 text-center">Crop Image</label>

          <button class="btn-modal-close" v-on:click="hideCropperModal()">
            &times;
          </button>

          <vue-cropper
            ref="cropper"
            :src="imgSrc"
            :viewMode="1"
            :aspect-ratio="width / height"
            :cropBoxResizable="true"
            dragMode="none"
            alt="Source Image"
            preview=".preview"
          ></vue-cropper>
          <br />
          <button
            class="btn-blue d-block mr-auto ml-auto"
            @click.prevent.stop="cropImage"
          >
            Save
          </button>
        </b-modal>
      </div>
    </div>
    <ImageGallery
      v-bind:propImageName="banner_name ? banner_name : 'Movie Banner'"
      v-bind:openModal="showModal"
      v-bind:set_height="set_height"
      v-bind:set_width="set_width"
      :showPercentageLoader="true"
      :img_desc="banner_description ? banner_description : 'Movie Banner'"
      :resetImgData="false"
      :category="'Movie Banner'"
    ></ImageGallery>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import MovieService from "@/services/MovieService";
  import MarketingService from "@/services/MarketingService";
  import Vue from "vue";

  import VueCropper from "vue-cropperjs";
  import "cropperjs/dist/cropper.css";
  import moment from "moment";
  import ImageGallery from "../../ImageGallery/imageGalleryModal";
  import { mapGetters } from "vuex";
  import ImagePreviewer from "@/components/Partials/ImagePreviewer.vue";

  export default {
    components: { VueCropper, ImageGallery, ImagePreviewer },
    data() {
      return {
        mobileImageSettingAvailable: false,
        submitted: false,
        btenable: false,
        banner_name: "",
        banner_header: "",
        banner_subheader: "",
        banner_is_active: true,
        fade: true,
        banner_description: "",
        banner_image: {
          image_setting_name: "Banner Image",
          image_setting_path: null,
          image_setting_static_path: "",
          image_setting_baseurl: "",
          image_setting_showpath: "",
        },
        mobile_banner_image: {
          image_setting_name: "Banner Image",
          image_setting_path: null,
          image_setting_static_path: "",
          image_setting_baseurl: "",
          image_setting_showpath: "",
        },
        file: null,
        filename: null,
        width: null,
        height: null,
        cropImg: null,
        tempModalImageName: null,
        tempModalImagePath: null,
        imgSrc: null,
        MovieList: [],
        MovieListCopy: [],
        movie_name: "",
        movie_id: null,
        movie_original_lang_id: 0,
        searchMovie: "",
        isMovieSelected: false,
        isGenericURL: false,
        generic_url: "",
        showMovie: true,
        banner_type_id: null,
        banner_type: "",
        banner_types: [],
        MovieContentContainer: [],
        postersList: [],
        scenesList: [],
        cinemas: [],
        cinema_id: null,
        cinemaSelected: null,
        CinemasGroupedByRegion: [],
        selectedCinema: [],
        ContentLanguages: [],
        BannerContent: [],
        translationLoading: [false, false, false, false, false, false],
        translated: [false, false, false, false, false, false],
        unique_id: "",
        from_date: "",
        to_date: "",
        banner_image_height: "",
        banner_image_width: "",
        mobile_banner_image_height: "",
        mobile_banner_image_width: "",
        imageBannerIndex: "",
        set_width: null,
        set_height: null,
        showModal: false,
        movie_banner_type_id: 1,
        uploadType: 1,
        movieType: [
          {
            id: 1,
            name: "Now Showing",
            checked: false,
          },
          {
            id: 2,
            name: "On Demand",
            checked: false,
          },
          {
            id: 3,
            name: "Upcoming",
            checked: false,
          },
        ],
        offersList: [],
        selectedOfferId: { os_id: null },
      };
    },
    beforeMount() {
      this.getMoviesList();
    },
    mounted() {
      this.cinema_id = this.secureStore.get("USINFO").cinema_id || null;
      this.getCinemas();
      const { b_id } = this.$route.params;
      this.unique_id = b_id;
      // this.getContentLangauge();
      this.getBannerTypes();
    },
    computed: {
      ...mapGetters(["finalImagePath", "finalHeight", "finalWidth"]),
      movie_type_id() {
        let tempArr = [];
        this.movieType.map((x) => {
          if (x.checked) {
            tempArr.push(x.id);
          }
        });
        return tempArr.toString();
      },
    },
    watch: {
      finalImagePath(newval) {
        if (this.uploadType == 2) {
          this.BannerContent[
            this.imageBannerIndex
          ].mobile_banner_image.image_setting_path = newval;
        } else {
          this.BannerContent[
            this.imageBannerIndex
          ].banner_image.image_setting_path = newval;
          this.BannerContent[this.imageBannerIndex].isNewUpload = true;
        }
        this.$forceUpdate();
      },
      finalHeight(newval) {
        this.BannerContent[this.imageBannerIndex]["image_height"] = newval;

        this.BannerContent[this.imageBannerIndex].isNewUpload = true;
        this.$forceUpdate();
      },
      finalWidth(newval) {
        this.BannerContent[this.imageBannerIndex]["image_width"] = newval;

        this.BannerContent[this.imageBannerIndex].isNewUpload = true;
        this.$forceUpdate();
      },
    },
    methods: {
      moment,
      removeImageHandler(BannerLang, type) {
        if (type == 2) {
          BannerLang.mobile_banner_image.image_setting_path = null;
        } else {
          BannerLang.banner_image.image_setting_path = null;
          BannerLang.is_compressed = "N";
          BannerLang.original_banner_image_url = null;
          BannerLang.image_height = 0;
          BannerLang.image_width = 0;
        }
        this.$forceUpdate();
      },
      downloadImage(obj, type) {
        console.log(obj);
        let imgPath = "";
        let fileName = "";
        let extension_array = "";
        let actual_extension = "";
        let banner_type_id = this.banner_type_id;
        if (banner_type_id == 1) {
          let movieName = this.MovieList.filter((x) => {
            return x.movie_id == this.movie_id;
          })[0]["movie_unique_identifier"].replaceAll(".", "");
          if (type == 2) {
            imgPath = obj.mobile_banner_image.image_setting_path;
            extension_array = imgPath.split(".");
            actual_extension = extension_array[extension_array.length - 1];
          } else {
            imgPath = obj.banner_image.image_setting_path.includes(
              "BannerMinified"
            )
              ? obj.original_banner_image_url
              : obj.banner_image.image_setting_path;
            extension_array = imgPath.split(".");
            actual_extension = extension_array[extension_array.length - 1];
          }
          fileName = `${movieName}_webbanner_${obj.image_width}x${obj.image_height}_${obj.iso_3}.${actual_extension}`;
        } else if (banner_type_id == 2) {
          if (type == 2) {
            imgPath = obj.mobile_banner_image.image_setting_path;
            extension_array = imgPath.split(".");
            actual_extension = extension_array[extension_array.length - 1];
          } else {
            imgPath = obj.banner_image.image_setting_path.includes(
              "BannerMinified"
            )
              ? obj.original_banner_image_url
              : obj.banner_image.image_setting_path;
            extension_array = imgPath.split(".");
            actual_extension = extension_array[extension_array.length - 1];
          }
          fileName = `generic_webbanner_${this.banner_name}_${obj.image_width}x${obj.image_height}_${obj.iso_3}.${actual_extension}`;
        }
        this._downloadImagePath(imgPath, fileName);
      },
      checkInputLength(event) {
        console.log("event", event);
        let maxlength = event.target.maxLength;
        var regex = new RegExp("^[a-zA-Z0-9 ]+$");
        var str = String.fromCharCode(
          !event.charCode ? event.which : event.charCode
        );
        if (
          event.target.value.length >= event.target.maxLength &&
          regex.test(str)
        ) {
          this.$toasted.show(
            `Limit Reached. Only ${maxlength} characters are allowed.`
          );
        }
      },
      setModalData(height, width, index, uploadType = 1) {
        this.imageBannerIndex = index;
        this.set_height = height;
        this.set_width = width;
        this.uploadType = uploadType;
        this.showModal = !this.showModal;
      },
      async getCinemas() {
        try {
          const { data } = await MasterService.GetCinemas({
            cine_id: this.cinema_id,
          });
          if (data && data.status && data.Records.length > 0) {
            this.cinemas = data.Records;
            this.CinemasGroupedByRegion = _.toPairs(
              _.groupBy(
                data.Records.filter((x) => x.region_id),
                "region_id"
              )
            );
            this.getBanner();
          }
        } catch (error) {
          console.error(error);
        }
      },
      resetFromDate(type) {
        if (type == "from_date") {
          this.from_date = "";
        } else if (type == "to_date") {
          this.to_date = "";
        }
      },
      getContentLangauge: function (content) {
        MovieService.GetMovieContentLanguages()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.ContentLanguages.length > 0) {
                // this.ContentLanguages = _.sortBy(data.ContentLanguages, [
                //   "langauge"
                // ]);
                this.ContentLanguages = data.ContentLanguages;
              }
              console.log("this.ContentLanguages", this.ContentLanguages);
            } else {
              // Show Error:
              console.log("data.message :", data.message);
            }
            return;
          })
          .then(() => {
            this.makeLangContainers(content);
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error On getMovieContentLangauge :", error);
          });
      },
      _makeLangContainers: function (content) {
        this.ContentLanguages.map((x) => {
          let Obj = {
            ...x,
            banner_name: "",
            banner_header: "",
            banner_subheader: "",
            banner_description: "",
          };
          this.BannerContent.push(Obj);
          console.log("this.BannerContent", this.BannerContent);
        });
      },
      makeLangContainers: function (Content) {
        let Obj;
        console.log("Content", Content);
        this.ContentLanguages.map((x, i) => {
          let Array1 = Content.filter((y) => {
            return y.lang_id == x.langaugeId;
          });
          if (Array1.length > 0) {
            x["b_id"] = Array1[0].b_id;
            x["unique_id"] = Array1[0].unique_id;
            x["banner_header"] = Array1[0].banner_header;
            x["banner_subheader"] = Array1[0].banner_subheader;
            x["button_text"] = Array1[0].button_text;
            x["is_compressed"] = Array1[0].is_compressed;
            x["isNewUpload"] = false;
            x["image_height"] = Array1[0].image_height;
            x["image_width"] = Array1[0].image_width;
            x["original_banner_image_url"] =
              Array1[0].original_banner_image_url;
            let InsObj = {
              image_setting_path: Array1[0].banner_image_url,
              image_setting_name: "Web Banner",
              image_setting_static_path: "",
              image_setting_baseurl: "",
              image_setting_showpath: "",
            };
            let mobile_InsObj = {
              image_setting_path: Array1[0].mobile_banner_image_url,
              image_setting_name: "Mobile Banner",
              image_setting_static_path: "",
              image_setting_baseurl: "",
              image_setting_showpath: "",
            };
            x["banner_image"] = InsObj;
            x["mobile_banner_image"] = mobile_InsObj;
          } else {
            x["banner_header"] = "";
            x["banner_subheader"] = "";
            x["button_text"] = "";
            x["is_compressed"] = "N";
            x["isNewUpload"] = false;
            x["image_height"] = 0;
            x["image_width"] = 0;
            x["original_banner_image_url"] = null;
            let InsObj = {
              image_setting_path: null,
              image_setting_name: "Banner Image",
              image_setting_static_path: "",
              image_setting_baseurl: "",
              image_setting_showpath: "",
            };
            let mobile_InsObj = {
              image_setting_path: null,
              image_setting_name: "Mobile Banner",
              image_setting_static_path: "",
              image_setting_baseurl: "",
              image_setting_showpath: "",
            };
            x["banner_image"] = InsObj;
            x["mobile_banner_image"] = mobile_InsObj;
          }
        });
        this.BannerContent = this.ContentLanguages;
        console.log("hjhf", this.ContentLanguages);
      },
      translateToOtherLangs: function (Content, index) {
        /* movieDescription
movieShortDescription */
        let englishContent = this.BannerContent.find((x) => {
          if (
            (x.banner_header && x.banner_header.length > 0) ||
            (x.banner_subheader && x.banner_subheader.length > 0)
          ) {
            return true;
          }
        });

        if (
          !englishContent ||
          !englishContent.banner_header ||
          !englishContent.banner_subheader
        ) {
          this.$toasted.show("Please enter all details for any language");
          return;
        }

        let targetLang = Content.iso_2;

        if (!targetLang) {
          this.$toasted.show(
            "No ISO code found for " + Content.langauge + "language"
          );
          return;
        }
        this.translationLoading[index] = true;

        this.$forceUpdate();

        MovieService.GetDeeplTranslations({
          target_langs: [targetLang],
          text: [
            englishContent.banner_header,
            englishContent.banner_subheader,
            englishContent.button_text,
          ],
        })
          .then((resp) => {
            const { data } = resp;
            console.log("data", data);

            if (data.status) {
              let translations = data.data[targetLang].translations;
              Content.banner_header = translations[0].text;
              Content.banner_subheader = translations[1].text;
              Content.button_text = translations[2].text;
              this.translated[index] = true;
            }
          })
          .catch((err) => {
            this.$toasted.show("Error when fetching translations");
            console.log("Error while fetching translations");
            console.log(err);
          })
          .finally(() => {
            this.translationLoading[index] = false;
            this.$forceUpdate();
          });
      },
      onClickSelectCinema(cinema, index) {
        // let isExists = this.selectedCinema.find((x) => {
        //   return x.cine_id == cinema.cine_id
        // })
        let isExists = this.selectedCinema.findIndex(
          (x) => x.cine_id == cinema.cine_id
        );
        // if(isExists) {
        //   this.selectedCinema.splice(this.selectedCinema.findIndex(function(i){
        //     return i.cine_id === cinema.cine_id;
        // }), 1);
        // } else {
        //   this.selectedCinema.push(cinema);
        // }
        if (isExists !== -1) {
          this.selectedCinema.splice(isExists, 1);
        } else {
          this.selectedCinema.push(cinema);
        }
        console.log("selectedScreens", this.selectedCinema);
      },
      getBanner() {
        const { b_id } = this.$route.params;
        MasterService.GetSingleBanner({ b_id: b_id })
          .then(async (response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records[0].movie_id) {
                this.movie_id = data.Records[0].movie_id;
                this.movie_original_lang_id = data.Records[0].original_lang_id;
                this.isMovieSelected = true;
                this.getMoviesList(this.movie_id);
                this.cinemaSelected = this.cinemas.find(
                  (cinema) => cinema.cine_id === data.Records[0].cinema_id
                );
                // this.selectedCinema = data.cinema.map((x) => cine_id = x.cinema_id)
                console.log("this.selectedCinema", this.selectedCinema);
              } else if (
                data.Records[0].banner_type_id !== 1 &&
                data.Records[0].banner_generic_url &&
                data.Records[0].banner_generic_url.length > 0 &&
                data.Records[0].movie_details_id == null
              ) {
                this.showMovie = false;
                this.isGenericURL = true;
                this.getMoviesList();
              }
              this.getContentLangauge(data.cinema[0].cinema);
              this.selectedCinema = data.cinema.map((x) => {
                let obj = {
                  cine_id: x.cinema_id,
                  unique_id: x.cinema[0].unique_id,
                };
                return obj;
              });
              this.banner_name = data.Records[0].banner_name;
              this.banner_header = data.Records[0].banner_header;
              this.banner_subheader = data.Records[0].banner_subheader;
              this.movie_banner_type_id = data.Records[0].movie_banner_type_id
                ? data.Records[0].movie_banner_type_id
                : 1;
              this.banner_description = data.Records[0].description;
              if (data.Records[0].banner_type_id == 4) {
                await this.getOffersList();
                let selectedOfferTitle = this.offersList.find((offersObj) => {
                  return offersObj.os_id == data.Records[0].banner_os_id;
                });
                this.selectedOfferId = {
                  os_id: data.Records[0].banner_os_id,
                  offer_title:
                    selectedOfferTitle &&
                    selectedOfferTitle.hasOwnProperty("offer_title")
                      ? selectedOfferTitle.offer_title
                      : "",
                };
              }
              this.banner_image.image_setting_path =
                data.Records[0].banner_image_url;
              this.banner_is_active =
                data.Records[0].banner_is_active == "Y" ? true : false;
              this.fade = data.Records[0].fade == "Y" ? true : false;
              this.generic_url = data.Records[0].banner_generic_url;
              this.banner_type_id = data.Records[0].banner_type_id;
              this.from_date = data.Records[0].from_date
                ? data.Records[0].from_date
                : "";
              this.to_date = data.Records[0].to_date
                ? data.Records[0].to_date
                : "";
              // this.from_date = data.Records[0].from_date ? moment(data.Records[0].from_date).format("DD-MM-YYYY") : "";
              // this.to_date = data.Records[0].to_date ? moment(data.Records[0].to_date).format("DD-MM-YYYY") : "";
              this.tempModalImageName = "Banner Image";
              this.tempModalImagePath = data.Records[0].banner_image_url;

              if (data.Records[0].movie_banner_type_id) {
                let movieTypeIds =
                  data.Records[0].movie_banner_type_id.split(",");
                console.log("movieTypeIds", movieTypeIds);
                this.movieType.forEach((x) => {
                  if (movieTypeIds.includes(x.id.toString())) {
                    x["checked"] = true;
                  }
                });
              }

              if (this.banner_types.length > 0) {
                this.banner_types.forEach((bt) => {
                  if (bt.banner_type_id === this.banner_type_id) {
                    this.banner_type = bt.banner_type;
                  }
                });
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      getBannerTypes: function () {
        MasterService.GetBannerTypes().then((res) => {
          const { data } = res;
          if (data.status) {
            this.banner_types = data.Records;
            if (data.bannerSettings) {
              let webbanner = data.bannerSettings.filter(
                (x) => x.image_setting_name.toLowerCase() == "web banner"
              );
              if (webbanner && webbanner.length > 0) {
                this.banner_image_height = webbanner[0].image_setting_height;
                this.banner_image_width = webbanner[0].image_setting_width;
              }

              let mobilebanner = data.bannerSettings.filter(
                (x) =>
                  x.image_setting_name.toLowerCase() == "mobile banner" &&
                  x.image_setting_is_active == "Y"
              );
              if (mobilebanner && mobilebanner.length > 0) {
                this.mobileImageSettingAvailable = true;
                this.mobile_banner_image_height =
                  mobilebanner[0].image_setting_height;
                this.mobile_banner_image_width =
                  mobilebanner[0].image_setting_width;
              }
            }

            if (this.banner_type_id) {
              this.banner_types.forEach((bt) => {
                if (bt.banner_type_id === this.banner_type_id) {
                  this.banner_type = bt.banner_type;
                }
              });
            }
          }
        });
      },
      onSelectBannerType: function (data) {
        this.banner_type = data.banner_type;
        this.banner_type_id = data.banner_type_id;

        console.log("onSelectBannerType", data);
        console.log(
          "this.movie_original_lang_id",
          this.movie_id,
          this.movie_original_lang_id
        );

        if (
          data.banner_type_id == 2 &&
          this.movie_id &&
          this.movie_original_lang_id
        ) {
          this.generic_url = `/movie-details/${this.movie_id}/${this.movie_original_lang_id}`;
        }
      },
      _getMoviesList: function (movie_id) {
        let loader = this.$loading.show();
        MovieService.GetActiveMoviesWithFormat()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.MovieList = data.Records;
              this.MovieListCopy = data.Records;

              this.MovieList.map((x) => {
                if (movie_id == x.movie_id) {
                  this.movie_name = x.movie;
                }
              });
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      getMoviesList: function (movie_id) {
        let loader = this.$loading.show();
        let payload = {
          movie_is_active: "Y",
        };
        MovieService.GetActiveMasterMovies(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.MovieList = data.Records;
              this.MovieListCopy = data.Records;

              this.MovieList.map((x) => {
                if (movie_id == x.movie_id) {
                  this.movie_name = x.movie_title;
                }
              });
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            console.log("Catch Error on getAllActiveMovies :", error);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      onSearchMovie: function (value) {
        if (this.searchMovie && this.searchMovie.length > 0) {
          this.MovieList = this.MovieListCopy.filter((x) => {
            if (
              x.movie_title
                .toLowerCase()
                .includes(this.searchMovie.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.MovieList = this.MovieListCopy;
        }
      },
      onSelectMovie: function (data) {
        // this.isMovieSelected = true;
        this.movie_name = data.movie_title;
        this.movie_id = data.movie_id;
        this.banner_name = data.movie_title;
        this.banner_description = data.movie_title;
        // this.banner_subheader = data.lang_name + " " + data.mf_name;
        // this.banner_description = data.mc_plot;
        this.banner_image.image_setting_path = "";
        this.BannerContent.map((x) => {
          if (x.langauge.toLowerCase() == "english") {
            x.banner_name = data.movie_title;
            x.banner_header = data.movie_title;
            // x.banner_subheader = data.lang_name + " " + data.mf_name;
            x.banner_subheader = data.movie_title;
            // x.banner_description = data.mc_plot;
            x.banner_description = data.movie_title;
          }
        });
        // this.tempModalImageName = "Banner Image";
        // this.tempModalImagePath = data.mp_poster_url;
        this.generic_url = `/movie-details/${data.movie_id}/${data.original_lang_id}`;

        // this.getMovieDetails(data.movie_id, data);
      },
      OnType: function (event) {
        if (this.generic_url.length > 0 && this.movie_id != null) {
          this.isGenericURL = false;
        } else if (this.generic_url.length > 0) {
          this.isGenericURL = true;
        } else {
          this.isGenericURL = false;
        }
      },
      setBannerImage: function (e, index) {
        this.imageBannerIndex = index;
        this.file = e.target.files[0];
        this.filename = e.target.files[0]["name"];
        //   this.indexofthubmnail = PosterIndex;
        //   this.movieindex = MovieContentIndex;

        this.width = this.banner_image_width;
        this.height = this.banner_image_height;

        if (this.file.type.indexOf("image/") === -1) {
          this.$toasted.show("Please select an image file");
          return;
        }
        if (typeof FileReader === "function") {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.imgSrc = event.target.result;

            this.$bvModal.show("imagecropper");
            e.target.value = "";
          };
          reader.readAsDataURL(this.file);
        } else {
          // alert("Sorry, FileReader API not supported");
        }
      },
      cropImage() {
        // get image data for post processing, e.g. upload or setting image src
        this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
        //   console.log(this.data);
        var block = this.cropImg.split(";");
        // Get the content type of the image
        var contentType = block[0].split(":")[1]; // In this case "image/gif"
        // get the real base64 content of the file
        var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
        // Convert it to a blob to upload
        var blob1 = this.b64toBlob(realData, contentType);
        this.onFileUpload(blob1, this.filename);
      },
      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || "";
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },
      onFileUpload: function (image, filename) {
        //   let loader = this.$loading.show();

        let formData = new FormData();
        formData.append("image", image, filename);
        formData.append("imagePath", "Banner Image");
        // formData.append("imagePath", PosterItem.image_setting_static_path);
        MasterService.GlobalUploadImage(formData)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              // this.MovieContentContainer[MovieContentIndex].moviePosters[
              //   PosterIndex
              // ].image_setting_path = data.path;
              this.onSetImagePath(data);
              this.$bvModal.hide("imagecropper");
            } else {
              data["message"] && data["message"]["message"]
                ? this.$toasted.show(data.message.message)
                : this.$toasted.show(
                    data.message ||
                      "Sorry! Something went wrong. kindly contact your administrator"
                  );
            }
          })
          .catch(this._CatchError);
        // .finally(() => {
        //   setTimeout(() => loader.hide(), 1000);
        // });
      },
      onSetImagePath: function (data, MovieContentIndex, PosterIndex) {
        //   let Obj = this.banner_image;
        //   console.log("Obj :>> ", Obj);
        //   let _Obj = {
        //     ...Obj,
        //     image_setting_path: data.path
        //   };
        //   Vue.set(this.banner_image, _Obj);
        this.BannerContent[
          this.imageBannerIndex
        ].banner_image.image_setting_path = data.path;
        this.$forceUpdate();
        // this.banner_image.image_setting_path = data.path;
        console.log("this.banner_image :>> ", this.banner_image);
      },
      openImageModal: function (image_name, image_path) {
        this.tempModalImagePath = image_path;
        this.tempModalImageName = image_name;
        this.$refs["preview-modal"].show();
      },
      hideCropperModal: function () {
        this.$bvModal.hide("imagecropper");
      },

      editBanner() {
        this.submitted = true;
        if (!this.banner_type) {
          return this.$toasted.show("Please Select Banner Type");
        } else if (this.selectedCinema.length == 0) {
          return this.$toasted.show("Please Select Cinema");
        } else if (this.from_date > this.to_date) {
          return this.$toasted.show("To Date must be greater than From Date");
        } else if (this.banner_type_id == 1 && !this.movie_type_id) {
          return this.$toasted.show("Please Select Movie Type");
        } else if (this.to_date && moment(this.to_date).isBefore(moment())) {
          return this.$toasted.show(
            "(To) date must be greater than (Current) date"
          );
        }
        const { b_id } = this.$route.params;
        this.$validator.validate().then((valid) => {
          let checkBanner = true;
          console.log("valide", valid);
          if (valid) {
            // if (this.movie_id == null && this.generic_url.length == 0) {
            //   return this.$toasted.show(
            //     "Please Select Movie or Enter Generic URL"
            //   );
            // }
            this.BannerContent.map((x) => {
              if (
                x.langauge.toLowerCase() == "english" &&
                !x.banner_image.image_setting_path
              ) {
                checkBanner = false;
              }
            });
            if (
              // this.banner_image.image_setting_path &&
              // this.banner_image.image_setting_path.length > 0
              checkBanner
            ) {
              // let loader = this.$loading.show();
              this.btenable = true;
              // console.log("JSON.stringify :", JSON.stringify(finalObj));
              let payload = {
                movie_id: this.movie_id,
                generic_url: this.generic_url,
                banner_name: this.banner_name,
                banner_description: this.banner_description,
                movie_banner_type_id:
                  this.banner_type_id == 1 ? this.movie_banner_type_id : null,
                banner_os_id: this.selectedOfferId.os_id,
                movie_type_id:
                  this.banner_type_id == 1 ? this.movie_type_id : "",
                // banner_header: this.banner_header,
                // banner_subheader: this.banner_subheader,
                BannerContent: this.BannerContent,
                selectedCinema: this.selectedCinema,
                image_url: this.banner_image.image_setting_path,
                banner_is_active: this.banner_is_active,
                fade: this.fade,
                b_id: b_id,
                banner_type_id: this.banner_type_id,
                cinema_id: this.selectedCinema.cine_id,
                from_date: this.from_date
                  ? moment(this.from_date).format("YYYY-MM-DD HH:mm:ss")
                  : "",
                to_date: this.to_date
                  ? moment(this.to_date).format("YYYY-MM-DD HH:mm:ss")
                  : "",
              };
              console.log("payload :>> ", payload);
              let loader = this.$loading.show();
              MasterService.EditBanner(payload)
                .then((response) => {
                  this.btenable = false;
                  const { data } = response;
                  // loader.hide();
                  if (data && data.status) {
                    this.$toasted.show(data.message);

                    this.$router.push({
                      path: "/master/banners",
                    });
                  } else {
                    this.btenable = false;
                    this.$toasted.show(data.message);
                  }
                })
                .catch((err) => {
                  console.log("Error:", err);
                })
                .finally(() => {
                  loader.hide();
                });
            } else {
              this.$toasted.show(
                "Please select a banner image for english language"
              );
            }
          }
        });
      },
      getMovieDetails(movie_id, movieDetails) {
        let loader = this.$loading.show();

        let payload = {
          movie_id,
        };

        this.postersList = [];
        this.scenesList = [];

        MovieService.GetEditMoviesDetails(payload)
          .then((response) => {
            const { data } = response;
            console.log("data :", data);
            if (data && data.status) {
              this.MovieContentContainer = _.sortBy(
                data.MovieContentContainer,
                ["langauge"]
              );
            } else {
              // Show Message Here
              console.log("data.message :", data.message);
              this.$toasted.show("Unable to fetch movie details").show();
            }

            console.log(
              "this.MovieContentContainer",
              this.MovieContentContainer
            );
            return data;
          })
          .then((data) => {
            let MovieContentContainer = data.MovieContentContainer;

            for (let content of MovieContentContainer) {
              let posters = content.moviePosters;
              let scenes = content.movieScenes;

              posters.forEach((poster) => {
                if (poster.image_setting_path) {
                  this.postersList.push({
                    ...poster,
                    language: content.langauge,
                  });
                }
              });

              scenes.forEach((scene) => {
                if (scene.image_path) {
                  this.scenesList.push({
                    ...scene,
                    language: content.langauge,
                  });
                }
              });
            }

            if (this.postersList.length > 0) {
              this.BannerContent.map((x) => {
                this.postersList.map((y) => {
                  if (x.langauge.toLowerCase() == y.language.toLowerCase()) {
                    x.banner_image.image_setting_path = y.image_setting_path;
                  }
                });
              });
            }

            console.log("this.posterList", this.postersList);

            if (this.postersList.length === 0 && this.scenesList.length === 0) {
              this.banner_image.image_setting_path =
                movieDetails.md_thumbnail_url;
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      onSelectPoster(poster) {
        console.log("poster", poster);
        this.banner_image.image_setting_path = poster.image_setting_path;
        this.tempModalImageName = "Banner Image";
        this.tempModalImagePath = poster.image_setting_path;
      },
      onSelectScene(scene) {
        console.log("scene", scene);
        this.banner_image.image_setting_path = scene.image_path;
        this.tempModalImageName = "Banner Image";
        this.tempModalImagePath = scene.image_path;
      },
      getOffersList: async function () {
        try {
          const response = await MarketingService.getOffersForBanners();
          const { data } = response;
          if (data.status && data.Records.length) {
            this.offersList = data.Records;
            // return;
          } else {
            this.$toasted.show(data.message);
          }
        } catch (error) {
          console.log({ error });
        }
      },
    },
  };
</script>

<style scoped>
  .dropdown-toggle {
    width: 100%;
  }

  .btn-dropdown-curve {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .img-preview:hover {
    left: -430px !important;
  }

  .new-border {
    border: 2px solid #b1b4b8;
  }

  label {
    color: black !important;
  }

  .internal-border-new {
    border: 1px solid var(--blue);
    /*background-color: #e6e6f8;*/
  }

  .internal-border {
    border: 1px solid var(--blue);
    background-color: #e6e6f8;
    display: flex;
    flex-wrap: wrap;
    border-radius: 10px;
    margin: 0 15px 15px 15px;
    padding-top: 15px;
  }

  .fs {
    font-size: 17px;
  }

  .back {
    background-color: #fff;
  }

  .mar {
    margin-left: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/BannerComponents/editBanner.vue